// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

export const zLoginUserDto = z.object({
  email: z.email(),
  password: z.string(),
});

export const zSubject = z.enum([
  'All',
  'User',
  'Organization',
  'AuditEntry',
  'ParkingFacility',
  'Station',
  'ParkAndRideFacility',
]);

export const zUserStatus = z.enum(['ACTIVE', 'INACTIVE', 'INVITED']);

export const zUserRole = z.enum(['ADMIN', 'USER']);

export const zOrganizationUserRole = z.enum(['MANAGER', 'EDITOR']);

export const zOrganizationType = z.enum(['MUNICIPAL', 'PARKING_OPERATOR', 'THIRD_PARTY_SERVICE', 'OTHER']);

export const zDataSource = z.enum([
  'INTERNAL',
  'PARKING_FACILITY__FRANKFURT__PRISMA',
  'PARKING_FACILITY_DATA__FRANKFURT__PRISMA',
  'PARK_AND_RIDE_FACILITY_DATA__FRANKFURT__PARKING_PILOT',
]);

export const zTrafficSign = z.enum(['P_314', 'PR', 'NONE', 'OTHER']);

export const zFacilityType = z.enum([
  'SEPARATE_AREA',
  'ON_STREET_PARALLEL',
  'ON_STREET_ANGLED',
  'CURB_NO_MARKING',
  'MARKED_BAY_PARALLEL',
  'PARKING_GARAGE',
  'PARKDECK',
  'OTHER',
]);

export const zTracingParkingSpace = z.enum(['COUNTED', 'ESTIMATED', 'AUTOMATED']);

export const zTracingCapacity = z.enum(['COUNTED', 'ESTIMATED', 'AUTOMATED']);

export const zCapacityClass = z.enum(['LOW', 'MEDIUM', 'HIGH', 'FULL']);

export const zParkingSpaceMarking = z.enum(['NOT_MARKED', 'PARTIALLY_MARKED', 'MARKED']);

export const zTypeOfManagement = z.enum([
  'PARKING_METER',
  'OTHER',
  'DB_SERVICE_COUNTER',
  'NO_ONSITE_PARKING_PERMIT',
  'PARKING_TICKET_MACHINE',
]);

export const zEntranceProhibited = z.enum(['LPG', 'CNG']);

export const zParkingSurface = z.enum(['ASPHALT', 'GRAVEL', 'GRASS']);

export const zPointDto = z.object({
  type: z.enum(['Point']),
  coordinates: z.tuple([z.number().gte(-180).lte(180), z.number().gte(-180).lte(180)]),
});

export const zUsageExtent = z.enum(['LOW', 'MEDIUM', 'HIGH', 'UNCLEAR']);

export const zStationType = z.enum(['TRAIN', 'BUS']);

export const zAuditModel = z.enum(['ParkingFacility', 'Station', 'ParkAndRideFacility']);

export const zAuditAction = z.enum(['CREATE', 'UPDATE', 'DELETE']);

export const zJwtTokenType = z.enum(['ACCESS', 'REFRESH']);

export const zRefreshTokenDto = z.object({
  type: zJwtTokenType,
});

export const zInitializePasswordResetDto = z.object({
  email: z.email(),
});

export const zSubmitPasswordResetDto = z.object({
  password: z.string().min(8),
});

export const zCreateUserDto = z.object({
  role: zUserRole,
  organizationUserRole: zOrganizationUserRole.optional(),
  email: z.email(),
  organizationId: z.uuid().optional(),
});

export const zUpdateUserDto = z.object({
  role: zUserRole.optional(),
  organizationUserRole: zOrganizationUserRole.optional(),
  email: z.email().optional(),
  organizationId: z.uuid().optional(),
  status: zUserStatus.optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  password: z.string().min(8).optional(),
});

export const zAction = z.enum(['MANAGE', 'CREATE', 'READ', 'READ_ALL', 'UPDATE', 'DELETE']);

export const zCaslEnumDto = z.object({
  action: zAction,
  subject: zSubject,
});

export const zCaslRulesDto = z.object({
  rules: z.array(z.array(z.union([zAction, zSubject, z.string(), z.number(), z.record(z.string(), z.unknown())]))),
});

export const zAcceptInvitationDto = z.object({
  firstName: z.string(),
  lastName: z.string(),
  password: z.string().min(8),
});

export const zCreateOrganizationDto = z.object({
  name: z.string(),
  contact: z.string().nullish(),
  url: z.string().nullish(),
  organizationType: z.enum(['MUNICIPAL', 'PARKING_OPERATOR', 'THIRD_PARTY_SERVICE', 'OTHER']),
});

export const zUpdateOrganizationDto = z.object({
  name: z.string().optional(),
  contact: z.string().nullish(),
  url: z.string().nullish(),
  organizationType: zOrganizationType.optional(),
});

export const zCreateOrganizationUserDto = z.object({
  role: zOrganizationUserRole,
  email: z.email(),
});

export const zUpdateOrganizationUserDto = z.object({
  role: zOrganizationUserRole.optional(),
});

export const zCreateParkingFacilityDto = z.object({
  name: z.string(),
  organizationId: z.uuid(),
});

export const zUpdateParkingFacilityDto = z.object({
  name: z.string().optional(),
  organizationId: z.uuid().optional(),
  parkingSpaceLastUpdate: z.iso.datetime().nullish(),
  trafficSign: zTrafficSign.nullish(),
  facilityType: zFacilityType.nullish(),
  capacityDate: z.iso.datetime().nullish(),
  entranceProhibited: z.array(zEntranceProhibited).nullish(),
  usable: z.boolean().optional(),
  geometry: zPointDto.optional(),
  entranceStreet: z.string().optional(),
  entranceHouseNumber: z.string().optional(),
  entranceSecondaryStreet: z.string().optional(),
  entranceSecondaryHouseNumber: z.string().optional(),
  postalCode: z.string().optional(),
  city: z.string().optional(),
  prOfficial: z.boolean().optional(),
  numParkingSpaceTotal: z.number().optional(),
  numParkingSpaceDisabled: z.number().nullish(),
  numParkingSpaceWomen: z.number().nullish(),
  numParkingSpaceMotorcycle: z.number().nullish(),
  tracingParkingSpace: z.enum(['COUNTED', 'ESTIMATED', 'AUTOMATED']).optional(),
  capacityClass: z.enum(['LOW', 'MEDIUM', 'HIGH', 'FULL']).optional(),
  capacityPercentage: z.number().optional(),
  trafficSignAdditional: z.string().nullish(),
  tracingCapacity: z.enum(['COUNTED', 'ESTIMATED', 'AUTOMATED']).optional(),
  prUsageComment: z.string().nullish(),
  usageExtent: z.enum(['LOW', 'MEDIUM', 'HIGH', 'UNCLEAR']).optional(),
  parkingSpaceMarking: z.enum(['NOT_MARKED', 'PARTIALLY_MARKED', 'MARKED']).optional(),
  lighting: z.boolean().optional(),
  typeOfManagement: z
    .enum(['PARKING_METER', 'OTHER', 'DB_SERVICE_COUNTER', 'NO_ONSITE_PARKING_PERMIT', 'PARKING_TICKET_MACHINE'])
    .optional(),
  entranceHeight: z.number().nullish(),
  entranceWidth: z.number().nullish(),
  isAlwaysOpen: z.boolean().optional(),
  openingHours: z.string().nullish(),
  freeToUse: z.boolean().optional(),
  managementUrl: z.string().nullish(),
  isParkingUnlimited: z.boolean().optional(),
  parkingDuration: z.string().nullish(),
  prStatusNote: z.string().nullish(),
  parkingSurface: z.enum(['ASPHALT', 'GRAVEL', 'GRASS']).optional(),
  publication: z.boolean().optional(),
});

export const zCreateStationDto = z.object({
  type: zStationType,
  name: z.string(),
  rmvId: z.string(),
  rmvNumber: z.number(),
  geometry: zPointDto,
});

export const zUpdateStationDto = z.object({
  type: zStationType.optional(),
  name: z.string().optional(),
  rmvId: z.string().optional(),
  rmvNumber: z.number().optional(),
  geometry: zPointDto.optional(),
  stationComment: z.string().nullish(),
  numBrFacility: z.number().nullish(),
  numBikeParkingStation: z.number().nullish(),
  numBikeParkingCovered: z.number().nullish(),
  numBikeReadyToRide: z.number().nullish(),
});

export const zCreateParkAndRideFacilityDto = z.object({
  name: z.string(),
  organizationId: z.uuid(),
  stationId: z.uuid().optional(),
  rmvId: z.string().optional(),
});

export const zUpdateParkAndRideFacilityDto = z.object({
  name: z.string().optional(),
  organizationId: z.uuid().optional(),
  stationId: z.uuid().optional(),
  rmvId: z.string().optional(),
  parkingSpaceLastUpdate: z.iso.datetime().nullish(),
  trafficSign: zTrafficSign.nullish(),
  facilityType: zFacilityType.nullish(),
  capacityDate: z.iso.datetime().nullish(),
  entranceProhibited: z.array(zEntranceProhibited).nullish(),
  usable: z.boolean().optional(),
  geometry: zPointDto.optional(),
  entranceStreet: z.string().optional(),
  entranceHouseNumber: z.string().optional(),
  entranceSecondaryStreet: z.string().optional(),
  entranceSecondaryHouseNumber: z.string().optional(),
  postalCode: z.string().optional(),
  city: z.string().optional(),
  prOfficial: z.boolean().optional(),
  numParkingSpaceTotal: z.number().optional(),
  numParkingSpaceDisabled: z.number().nullish(),
  numParkingSpaceWomen: z.number().nullish(),
  numParkingSpaceMotorcycle: z.number().nullish(),
  tracingParkingSpace: z.enum(['COUNTED', 'ESTIMATED', 'AUTOMATED']).optional(),
  capacityClass: z.enum(['LOW', 'MEDIUM', 'HIGH', 'FULL']).optional(),
  capacityPercentage: z.number().optional(),
  trafficSignAdditional: z.string().nullish(),
  tracingCapacity: z.enum(['COUNTED', 'ESTIMATED', 'AUTOMATED']).optional(),
  prUsageComment: z.string().nullish(),
  usageExtent: z.enum(['LOW', 'MEDIUM', 'HIGH', 'UNCLEAR']).optional(),
  parkingSpaceMarking: z.enum(['NOT_MARKED', 'PARTIALLY_MARKED', 'MARKED']).optional(),
  lighting: z.boolean().optional(),
  toStationAccessibility: z.boolean().optional(),
  typeOfManagement: z
    .enum(['PARKING_METER', 'OTHER', 'DB_SERVICE_COUNTER', 'NO_ONSITE_PARKING_PERMIT', 'PARKING_TICKET_MACHINE'])
    .optional(),
  entranceHeight: z.number().nullish(),
  entranceWidth: z.number().nullish(),
  isAlwaysOpen: z.boolean().optional(),
  openingHours: z.string().nullish(),
  freeToUse: z.boolean().optional(),
  managementUrl: z.string().nullish(),
  isParkingUnlimited: z.boolean().optional(),
  parkingDuration: z.string().nullish(),
  prStatusNote: z.string().nullish(),
  parkingSurface: z.enum(['ASPHALT', 'GRAVEL', 'GRASS']).optional(),
  publication: z.boolean().optional(),
});

export const zCreateContactRequestDto = z.object({
  salutation: z.string().max(20),
  firstName: z.string().max(50),
  lastName: z.string().max(50),
  email: z.email(),
  location: z.string().max(200).optional(),
  message: z.string().max(2000),
});

export const zParkingFacility = z.object({
  __caslSubjectType__: zSubject,
  dataSource: zDataSource,
  trafficSign: zTrafficSign.nullable(),
  facilityType: zFacilityType.nullable(),
  numParkingSpaceTotal: z.int().nullable(),
  tracingParkingSpace: zTracingParkingSpace.nullable(),
  tracingCapacity: zTracingCapacity.nullable(),
  capacityClass: zCapacityClass.nullable(),
  numParkingSpaceDisabled: z.int().nullable(),
  numParkingSpaceWomen: z.int().nullable(),
  numParkingSpaceMotorcycle: z.int().nullable(),
  parkingSpaceMarking: zParkingSpaceMarking.nullable(),
  typeOfManagement: zTypeOfManagement.nullable(),
  entranceProhibited: z.array(zEntranceProhibited).nullable(),
  parkingSurface: zParkingSurface.nullable(),
  deletedAt: z.iso.datetime(),
  externalId: z.string(),
  organizationId: z.string().nullable(),
  organization: z.lazy((): any => zOrganization).optional(),
  name: z.string(),
  geometry: zPointDto.nullable(),
  entranceStreet: z.string().nullable(),
  entranceHouseNumber: z.string().nullable(),
  entranceSecondaryStreet: z.string().nullable(),
  entranceSecondaryHouseNumber: z.string().nullable(),
  postalCode: z.string().nullable(),
  city: z.string().nullable(),
  trafficSignAdditional: z.string().nullable(),
  parkingSpaceLastUpdate: z.iso.datetime().nullable(),
  capacityPercentage: z.number().nullable(),
  capacityDate: z.iso.datetime().nullable(),
  lighting: z.boolean().nullable(),
  entranceHeight: z.number().nullable(),
  entranceWidth: z.number().nullable(),
  isAlwaysOpen: z.boolean(),
  openingHours: z.string().nullable(),
  freeToUse: z.boolean(),
  managementUrl: z.string().nullable(),
  isParkingUnlimited: z.boolean(),
  parkingDuration: z.string().nullable(),
  usable: z.boolean().nullable(),
  publication: z.boolean(),
  id: z.string(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export const zStation = z.object({
  __caslSubjectType__: zSubject,
  rmvNumber: z.int().nullable(),
  type: zStationType,
  numBrFacility: z.int().nullable(),
  numBikeParkingStation: z.int().nullable(),
  numBikeParkingCovered: z.int().nullable(),
  numBikeReadyToRide: z.int().nullable(),
  deletedAt: z.iso.datetime(),
  rmvId: z.string(),
  name: z.string(),
  parkAndRideFacilities: z.array(z.lazy((): any => zParkAndRideFacility)).optional(),
  stationComment: z.string().nullable(),
  geometry: zPointDto.nullable(),
  id: z.string(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export const zParkAndRideFacility = z.object({
  __caslSubjectType__: zSubject,
  dataSource: zDataSource,
  trafficSign: zTrafficSign.nullable(),
  facilityType: zFacilityType.nullable(),
  numParkingSpaceTotal: z.int().nullable(),
  tracingParkingSpace: zTracingParkingSpace.nullable(),
  tracingCapacity: zTracingCapacity.nullable(),
  capacityClass: zCapacityClass.nullable(),
  numParkingSpaceDisabled: z.int().nullable(),
  numParkingSpaceWomen: z.int().nullable(),
  numParkingSpaceMotorcycle: z.int().nullable(),
  parkingSpaceMarking: zParkingSpaceMarking.nullable(),
  typeOfManagement: zTypeOfManagement.nullable(),
  entranceProhibited: z.array(zEntranceProhibited).nullable(),
  parkingSurface: zParkingSurface.nullable(),
  usageExtent: zUsageExtent.nullable(),
  stationId: z.string().nullable(),
  station: zStation.optional(),
  prOfficial: z.boolean().nullable(),
  prUsageComment: z.string().nullable(),
  toStationAccessibility: z.boolean().nullable(),
  prStatusNote: z.string().nullable(),
  legacyId: z.string().nullable(),
  rmvId: z.string().nullable(),
  deletedAt: z.iso.datetime(),
  externalId: z.string(),
  organizationId: z.string().nullable(),
  organization: z.lazy((): any => zOrganization).optional(),
  name: z.string(),
  geometry: zPointDto.nullable(),
  entranceStreet: z.string().nullable(),
  entranceHouseNumber: z.string().nullable(),
  entranceSecondaryStreet: z.string().nullable(),
  entranceSecondaryHouseNumber: z.string().nullable(),
  postalCode: z.string().nullable(),
  city: z.string().nullable(),
  trafficSignAdditional: z.string().nullable(),
  parkingSpaceLastUpdate: z.iso.datetime().nullable(),
  capacityPercentage: z.number().nullable(),
  capacityDate: z.iso.datetime().nullable(),
  lighting: z.boolean().nullable(),
  entranceHeight: z.number().nullable(),
  entranceWidth: z.number().nullable(),
  isAlwaysOpen: z.boolean(),
  openingHours: z.string().nullable(),
  freeToUse: z.boolean(),
  managementUrl: z.string().nullable(),
  isParkingUnlimited: z.boolean(),
  parkingDuration: z.string().nullable(),
  usable: z.boolean().nullable(),
  publication: z.boolean(),
  id: z.string(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export const zOrganization = z.object({
  __caslSubjectType__: zSubject,
  organizationType: zOrganizationType.nullable(),
  name: z.string(),
  users: z.array(z.lazy((): any => zOrganizationUser)).optional(),
  parkingFacilities: z.array(zParkingFacility).optional(),
  parkAndRideFacilities: z.array(zParkAndRideFacility).optional(),
  contact: z.string().nullable(),
  url: z.string().nullable(),
  id: z.string(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export const zInvitation = z.object({
  __caslSubjectType__: zSubject,
  validityDays: z.int().default(30),
  user: z.lazy((): any => zUser).optional(),
  id: z.string(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export const zAuditEntry = z.object({
  __caslSubjectType__: zSubject,
  model: zAuditModel,
  action: zAuditAction,
  id: z.string(),
  createdAt: z.iso.datetime(),
  user: z.lazy((): any => zUser).nullish(),
  data: z.record(z.string(), z.unknown()),
});

export const zUser = z.object({
  __caslSubjectType__: zSubject,
  status: zUserStatus,
  role: zUserRole,
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  email: z.string(),
  organization: z.lazy((): any => zOrganizationUser).nullish(),
  invitation: zInvitation.nullish(),
  auditEntries: z.array(zAuditEntry).optional(),
  id: z.string(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export const zOrganizationUser = z.object({
  __caslSubjectType__: zSubject,
  role: zOrganizationUserRole,
  organizationId: z.string(),
  organization: zOrganization.optional(),
  userId: z.string(),
  user: zUser.optional(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export const zParkingFacilityData = z.object({
  dataSource: zDataSource,
  numVacantSpaces: z.int().nullable(),
  facility: zParkingFacility,
  id: z.string(),
  timestamp: z.iso.datetime(),
  occupancyPercent: z.number(),
});

export const zParkAndRideFacilityData = z.object({
  dataSource: zDataSource,
  numVacantSpaces: z.int().nullable(),
  facility: zParkAndRideFacility,
  id: z.string(),
  timestamp: z.iso.datetime(),
  occupancyPercent: z.number(),
});

/**
 * The Health Check is successful
 */
export const zHealthCheckResponse = z.object({
  status: z.string().optional(),
  info: z
    .record(
      z.string(),
      z.object({
        status: z.string(),
      }),
    )
    .nullish(),
  error: z
    .record(
      z.string(),
      z.object({
        status: z.string(),
      }),
    )
    .nullish(),
  details: z
    .record(
      z.string(),
      z.object({
        status: z.string(),
      }),
    )
    .optional(),
});

export const zAuthenticationLogoutResponse = z.void();

export const zAuthenticationRefreshBody = zRefreshTokenDto;

export const zPasswordResetInitializeBody = zInitializePasswordResetDto;

export const zPasswordResetSubmitBody = zSubmitPasswordResetDto;

export const zPasswordResetSubmitPath = z.object({
  authenticationTokenId: z.string(),
});

export const zPasswordResetSubmitQuery = z.object({
  token: z.string(),
});

export const zPasswordResetSubmitResponse = z.record(z.string(), z.unknown());

export const zCaslGetRulesResponse = zCaslRulesDto;

export const zInvitationsAcceptBody = zAcceptInvitationDto;

export const zInvitationsAcceptPath = z.object({
  authenticationTokenId: z.string(),
});

export const zInvitationsAcceptQuery = z.object({
  token: z.string(),
});

export const zInvitationsAcceptResponse = z.record(z.string(), z.unknown());

export const zParkingFacilitiesExportCsvQuery = z.object({
  search: z.string().optional(),
  organizationId: z.uuid().optional(),
  publication: z.boolean().optional(),
});

export const zParkAndRideFacilitiesExportCsvQuery = z.object({
  search: z.string().optional(),
  stationId: z.uuid().optional(),
  organizationId: z.uuid().optional(),
  publication: z.boolean().optional(),
  stationless: z.boolean().optional(),
});

export const zContactRequestsCreateBody = zCreateContactRequestDto;

export const zAuthenticationGetUserResponse = zUser;

export const zAuthenticationLoginBody = zLoginUserDto;

export const zAuthenticationLoginResponse = zUser;

export const zUsersFindAllQuery = z.object({
  role: z.array(zUserRole).optional(),
  status: z.array(zUserStatus).optional(),
  search: z.string().optional(),
});

export const zUsersFindAllResponse = z.array(zUser);

export const zUsersCreateBody = zCreateUserDto;

export const zUsersCreateResponse = zUser;

export const zUsersRemovePath = z.object({
  userId: z.string(),
});

export const zUsersRemoveResponse = zUser;

export const zUsersFindOnePath = z.object({
  userId: z.string(),
});

export const zUsersFindOneResponse = zUser;

export const zUsersUpdateBody = zUpdateUserDto;

export const zUsersUpdatePath = z.object({
  userId: z.string(),
});

export const zUsersUpdateResponse = zUser;

export const zInvitationsReinvitePath = z.object({
  userId: z.string(),
});

export const zInvitationsReinviteResponse = zUser;

export const zOrganizationsFindAllQuery = z.object({
  search: z.string().optional(),
});

export const zOrganizationsFindAllResponse = z.array(zOrganization);

export const zOrganizationsCreateBody = zCreateOrganizationDto;

export const zOrganizationsCreateResponse = zOrganization;

export const zOrganizationsRemovePath = z.object({
  organizationId: z.string(),
});

export const zOrganizationsRemoveResponse = zOrganization;

export const zOrganizationsFindOnePath = z.object({
  organizationId: z.string(),
});

export const zOrganizationsFindOneQuery = z.object({
  users: z.boolean().optional(),
});

export const zOrganizationsFindOneResponse = zOrganization;

export const zOrganizationsUpdateBody = zUpdateOrganizationDto;

export const zOrganizationsUpdatePath = z.object({
  organizationId: z.string(),
});

export const zOrganizationsUpdateResponse = zOrganization;

export const zOrganizationsCreateOrganizationUserBody = zCreateOrganizationUserDto;

export const zOrganizationsCreateOrganizationUserPath = z.object({
  organizationId: z.string(),
});

export const zOrganizationsCreateOrganizationUserResponse = zOrganizationUser;

export const zOrganizationsRemoveOrganizationUserPath = z.object({
  organizationId: z.string(),
  userId: z.string(),
});

export const zOrganizationsRemoveOrganizationUserResponse = zOrganizationUser;

export const zOrganizationsFindOneOrganizationUserPath = z.object({
  organizationId: z.string(),
  userId: z.string(),
});

export const zOrganizationsFindOneOrganizationUserResponse = zOrganizationUser;

export const zOrganizationsUpdateOrganizationUserBody = zUpdateOrganizationUserDto;

export const zOrganizationsUpdateOrganizationUserPath = z.object({
  organizationId: z.string(),
  userId: z.string(),
});

export const zOrganizationsUpdateOrganizationUserResponse = zOrganizationUser;

export const zParkingFacilitiesFindAllQuery = z.object({
  search: z.string().optional(),
  organizationId: z.uuid().optional(),
  publication: z.boolean().optional(),
});

export const zParkingFacilitiesFindAllResponse = z.array(zParkingFacility);

export const zParkingFacilitiesCreateBody = zCreateParkingFacilityDto;

export const zParkingFacilitiesCreateResponse = zParkingFacility;

export const zParkingFacilitiesRemovePath = z.object({
  parkingFacilityId: z.string(),
});

export const zParkingFacilitiesRemoveResponse = zParkingFacility;

export const zParkingFacilitiesFindOnePath = z.object({
  parkingFacilityId: z.string(),
});

export const zParkingFacilitiesFindOneQuery = z.object({
  organization: z.boolean().optional(),
});

export const zParkingFacilitiesFindOneResponse = zParkingFacility;

export const zParkingFacilitiesUpdateBody = zUpdateParkingFacilityDto;

export const zParkingFacilitiesUpdatePath = z.object({
  parkingFacilityId: z.string(),
});

export const zParkingFacilitiesUpdateResponse = zParkingFacility;

export const zParkingFacilitiesFindAllAuditsPath = z.object({
  parkingFacilityId: z.string(),
});

export const zParkingFacilitiesFindAllAuditsResponse = z.array(zAuditEntry);

export const zParkingFacilitiesFindOneAuditPath = z.object({
  parkingFacilityId: z.string(),
  auditCreatedAt: z.string(),
});

export const zParkingFacilitiesFindOneAuditResponse = zAuditEntry;

export const zStationsFindAllQuery = z.object({
  search: z.string().optional(),
  organizationIds: z.array(z.uuid()).optional(),
  parkAndRideFacilitiesPublication: z.boolean().optional(),
});

export const zStationsFindAllResponse = z.array(zStation);

export const zStationsCreateBody = zCreateStationDto;

export const zStationsCreateResponse = zStation;

export const zStationsRemovePath = z.object({
  stationId: z.string(),
});

export const zStationsRemoveResponse = zStation;

export const zStationsFindOnePath = z.object({
  stationId: z.string(),
});

export const zStationsFindOneQuery = z.object({
  parkAndRideFacilities: z.boolean().optional(),
  parkAndRideFacilitiesPublication: z.boolean().optional(),
});

export const zStationsFindOneResponse = zStation;

export const zStationsUpdateBody = zUpdateStationDto;

export const zStationsUpdatePath = z.object({
  stationId: z.string(),
});

export const zStationsUpdateResponse = zStation;

export const zStationsFindAllAuditsPath = z.object({
  stationId: z.string(),
});

export const zStationsFindAllAuditsResponse = z.array(zAuditEntry);

export const zStationsFindOneAuditPath = z.object({
  stationId: z.string(),
  auditCreatedAt: z.string(),
});

export const zStationsFindOneAuditResponse = zAuditEntry;

export const zParkAndRideFacilitiesFindAllQuery = z.object({
  search: z.string().optional(),
  stationId: z.uuid().optional(),
  organizationId: z.uuid().optional(),
  publication: z.boolean().optional(),
  stationless: z.boolean().optional(),
});

export const zParkAndRideFacilitiesFindAllResponse = z.array(zParkAndRideFacility);

export const zParkAndRideFacilitiesCreateBody = zCreateParkAndRideFacilityDto;

export const zParkAndRideFacilitiesCreateResponse = zParkAndRideFacility;

export const zParkAndRideFacilitiesRemovePath = z.object({
  parkAndRideFacilityId: z.string(),
});

export const zParkAndRideFacilitiesRemoveResponse = zParkAndRideFacility;

export const zParkAndRideFacilitiesFindOnePath = z.object({
  parkAndRideFacilityId: z.string(),
});

export const zParkAndRideFacilitiesFindOneQuery = z.object({
  station: z.boolean().optional(),
  organization: z.boolean().optional(),
});

export const zParkAndRideFacilitiesFindOneResponse = zParkAndRideFacility;

export const zParkAndRideFacilitiesUpdateBody = zUpdateParkAndRideFacilityDto;

export const zParkAndRideFacilitiesUpdatePath = z.object({
  parkAndRideFacilityId: z.string(),
});

export const zParkAndRideFacilitiesUpdateResponse = zParkAndRideFacility;

export const zParkAndRideFacilitiesFindAllAuditsPath = z.object({
  parkAndRideFacilityId: z.string(),
});

export const zParkAndRideFacilitiesFindAllAuditsResponse = z.array(zAuditEntry);

export const zParkAndRideFacilitiesFindOneAuditPath = z.object({
  parkAndRideFacilityId: z.string(),
  auditCreatedAt: z.string(),
});

export const zParkAndRideFacilitiesFindOneAuditResponse = zAuditEntry;

export const zParkingDataFindAllLatestParkingFacilityDataResponse = z.array(zParkingFacilityData);

export const zParkingDataFindAllParkingFacilityDataResponse = z.array(zParkingFacilityData);

export const zParkingDataFindAllLatestParkAndRideFacilityDataResponse = z.array(zParkAndRideFacilityData);

export const zParkingDataFindAllParkAndRideFacilityDataResponse = z.array(zParkAndRideFacilityData);
